import React, {useState} from 'react';
import {Button, Input, Modal, Select} from "antd";
import {DeleteOutlined, PlusOutlined, CheckOutlined} from "@ant-design/icons";

const Istemolchilar = () => {
    const handleChange = (value) => {
        console.log(value); // { value: "lucy", key: "lucy", label: "Lucy (101)" }
    };

    const [open, setOpen] = useState(false);
    const showModal = () => {
        setOpen(true);
    };
    const handleOk = () => {
        setOpen(false);
    };
    const handleCancel = () => {
        setOpen(false);
    };
    return (
        <div>
            <table className="table table-bordered text-center">
                <thead className="align-middle bg-info">
                <tr>
                    <th style={{width: "50px"}}  scope="col">N</th>
                    <th scope="col">Iste'molchilar</th>
                    <th scope="col">Suv manbasi</th>
                    <th scope="col">Gidromodul</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <th scope="row"><input type="checkbox"/></th>
                    <td>Iste'molchilar 1</td>
                    <td>Suv manbasi 1</td>
                    <td>Gidromodul 1</td>
                </tr>
                <tr>
                    <th scope="row"><input type="checkbox"/></th>
                    <td>Iste'molchilar 2</td>
                    <td>Suv manbasi 2</td>
                    <td>Gidromodul 2</td>
                </tr>
                <tr>
                    <th scope="row"><input type="checkbox"/></th>
                    <td>Iste'molchilar 3</td>
                    <td>Suv manbasi 3</td>
                    <td>Gidromodul 3</td>
                </tr>
                </tbody>
            </table>
            <div className="add-data">
                <Button className="me-2" type="primary" icon={<PlusOutlined />} onClick={showModal}>
                    Yangi iste'molchi qo'shish
                </Button>
                <Button type="primary" danger icon={<DeleteOutlined />}>
                    O'chirish
                </Button>
            </div>

            <Modal
                title="Yangi iste'molchi nomi"
                open={open}
                onOk={handleOk}
                onCancel={handleCancel}
                width={1000}
                cancelText="Yopish"
            >
                <div className="row">
                    <div className="col-md-9">
                        <div className="mb-3">
                            <Input placeholder="Fermer xo'jaligi nomi" />
                        </div>
                        <table className="table table-bordered text-center">
                            <thead className="align-middle bg-info">
                            <tr>
                                <th style={{width: "50px"}}  scope="col">N</th>
                                <th scope="col">Tanlash</th>
                                <th scope="col">Suv manbalari</th>
                                <th scope="col">FIK</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <th scope="row"><input type="checkbox"/></th>
                                <td>Tanlash 1</td>
                                <td>Suv manbalari 1</td>
                                <td>1</td>
                            </tr>
                            <tr>
                                <th scope="row"><input type="checkbox"/></th>
                                <td>Tanlash 2</td>
                                <td>Suv manbalari 2</td>
                                <td>2</td>
                            </tr>
                            <tr>
                                <th scope="row"><input type="checkbox"/></th>
                                <td>Tanlash 3</td>
                                <td>Suv manbalari 3</td>
                                <td>3</td>
                            </tr>
                            </tbody>
                        </table>
                        <div className="add-data">
                            <Button className="me-2" type="primary" style={{ background: "green", borderColor: "green" }} icon={<CheckOutlined />}>
                                Saqlash
                            </Button>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <Select
                            labelInValue
                            defaultValue={{
                                value: 'Gidromodelni tanlang',
                                label: 'Gidromodelni tanlang',
                            }}
                            style={{
                                width: '100%',
                            }}
                            onChange={handleChange}
                            options={[
                                {
                                    value: '1',
                                    label: '1',
                                },
                                {
                                    value: '2',
                                    label: '2',
                                },
                                {
                                    value: '3',
                                    label: '3',
                                },
                                {
                                    value: '4',
                                    label: '4',
                                },
                            ]}
                        />
                    </div>
                </div>

            </Modal>
        </div>
    );
};

export default Istemolchilar;